import React, { Component } from "react";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { Fade, Slide } from "react-reveal";
import "./style.css";
import Swal from "sweetalert2";

const Contact = (props) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0f65ygq",
        "template_cgfw6of",
        form.current,
        "K5PQH47HJGyC7qX2k"
      )
      .then(
        (result) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: '<a href="">Why do I have this issue?</a>',
          });
        }
      );
    e.target.reset();
  };

  if (!props.data) return null;

  const name = props.data.name;
  const street = props.data.address.street;
  const city = props.data.address.city;
  const state = props.data.address.state;
  const zip = props.data.address.zip;
  const phone = props.data.phone;
  const message = props.data.contactmessage;
  return (
    <div>
      <div id="contact" className="contact">
        <section>
          <Fade bottom duration={1000}>
            <h1 style={{ color: "rgba(0, 148, 141, 1)", textAlign: "center" }}>
              Get In Touch.
            </h1>

            <div className="row section-head">
              <div className="two columns header-col"></div>

              <div className="ten columns">
                {/* <p className="lead">{message}</p> */}
              </div>
            </div>
          </Fade>

          <div className="row">
            <Slide left duration={1000}>
              <div className="eight columns">
                <form onSubmit={sendEmail} ref={form}>
                  <div>
                    <label htmlFor="user_name">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="user_name"
                      name="user_name"
                    />
                  </div>

                  <div>
                    <label htmlFor="user_email">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="user_email"
                      name="user_email"
                    />
                  </div>

                  <div>
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="subject"
                      name="subject"
                    />
                  </div>

                  <div>
                    <label htmlFor="message">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      cols="36"
                      rows="5"
                      id="message"
                      name="message"
                    ></textarea>
                  </div>

                  <div className="twelve offset-1 columns">
                    <input type="submit" value="send" className="submit" />
                  </div>
                </form>
              </div>
            </Slide>

            <Slide right duration={1000}>
              <aside id="colorwhite" className="four columns footer-widgets">
                <div className="widget widget_contact">
                  <h4>Address and Phone</h4>
                  <p className="address">
                    {name}
                    <br />
                    ------ <br />
                    Addis Ababa, Ethiopia
                    <br />
                    <span>{phone}</span>
                  </p>
                </div>

                <div className="widget widget_tweets">
                  <img src="/images/24.jpg" alt="qr code" />
                </div>
              </aside>
            </Slide>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
